import MainLayout from "../layout/main-layout";
import AuthGuard from "../utilities/constant/private-route";
import BlackList from "../views/blacklist";
import Blacklist from "../views/blacklist/blacklist-details";
import ReportDetails from "../views/blacklist/report-details";
import DashboardDefault from "../views/dashboard";
import AccountDetails from "../views/dashboard/account-details";
import Mediation from "../views/mediation";
import MediatorDetails from "../views/mediation/mediator-details";
import Notification from "../views/notification/notification";
import Refund from "../views/refunds";
import Settings from "../views/settings";
import CustomerSupport from "../views/customer-support";
import Transaction from "../views/transaction";
import TransactionDetails from "../views/transaction/transaction-details";
import PaymentRequest from "../views/transaction/transaction-details/payment-req";
import RequestDetails from "../views/customer-support/request-details";
import Analytics from "../views/analytics";
import Admins from "../views/admins";
import AdminDetails from "../views/admins/adminDetails";
import RefundDetails from "../views/refunds/refund-details";
import Roles from "../views/roles-and-privileges";
import RoleDetails from "../views/roles-and-privileges/roles/role-details";
import BalanceAdjustment from "../views/balance-adjustment";
import FeeManagement from "../views/fee-management";
import ReferralProgram from "../views/referral-program";
import TopAssociates from "../views/referral-program/top-associates";
import ReferredUsers from "../views/referral-program/referred-users";
import Campaign from "../views/campaign";
import AllocateVoucher from "../views/campaign/allocate-voucher";
import VoucherRedemptions from "../views/campaign/voucher-redemptions";
import EmailManagement from "../views/email-management";
import TemplateEditor from "../views/email-management/template-editor";
import CampaignEditor from "../views/email-management/campaign-editor";

const MainRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/",
      element: <DashboardDefault />,
    },
    {
      path: "/account/details/:id",
      element: <AccountDetails />,
    },
    {
      path: "/transactions",
      element: <Transaction />,
    },
    {
      path: "/refunds",
      element: <Refund />,
    },
    {
      path: "/transaction/details/:id",
      element: <TransactionDetails />,
    },
    {
      path: "/blacklist",
      element: <BlackList />,
    },
    {
      path: "/report/:id",
      element: <ReportDetails />,
    },
    {
      path: "/blacklists/report/:id",
      element: <Blacklist />,
    },
    {
      path: "/settings",
      element: <Settings />,
    },
    {
      path: "/mediation",
      element: <Mediation />,
    },

    {
      path: "/payment/request/:id",
      element: <PaymentRequest />,
    },

    {
      path: "/mediation/details/:_id",
      element: <MediatorDetails />,
    },
    {
      path: "/notification",
      element: <Notification />,
    },
    {
      path: "/support",
      element: <CustomerSupport />,
    },
    {
      path: "/admins",
      element: <Admins />,
    },
    {
      path: "/admins/detail/:id",
      element: <AdminDetails />,
    },
    {
      path: "/admins/profile-detail/:id",
      element: <AdminDetails />,
    },
    {
      path: "/request/:id",
      element: <RequestDetails />,
    },
    {
      path: "/analytics",
      element: <Analytics />,
    },
    {
      path: "/roles",
      element: <Roles />,
    },
    {
      path: "/roles/detail/:id",
      element: <RoleDetails />,
    },
    {
      path: "/refund/:id",
      element: <RefundDetails />,
    },
    {
      path: "/balance-adjustments",
      element: <BalanceAdjustment />,
    },
    {
      path: "/fee-management",
      element: <FeeManagement />,
    },
    {
      path: "/referral-program",
      element: <ReferralProgram />,
    },
    {
      path: "/referral-program/top-associates",
      element: <TopAssociates />,
    },
    {
      path: "/referral-program/referred-users",
      element: <ReferredUsers />,
    },
    {
      path: "/campaign",
      element: <Campaign />,
    },
    {
      path: "/campaign/allocate-voucher",
      element: <AllocateVoucher />,
    },
    {
      path: "/campaign/voucher-history/:recipientId",
      element: <AllocateVoucher />,
    },
    {
      path: "/campaign/voucher-redemptions",
      element: <VoucherRedemptions />,
    },
    {
      path: "/email-management",
      element: <EmailManagement />,
    },
    {
      path: "/email-management/campaigns/new",
      element: <CampaignEditor />,
    },
    {
      path: "/email-management/campaigns/:id",
      element: <CampaignEditor />,
    },
    {
      path: "/email-management/templates/new",
      element: <TemplateEditor />,
    },
    {
      path: "/email-management/templates/:id",
      element: <TemplateEditor />,
    },
  ],
};

export default MainRoutes;
